import { useEffect, useState, useCallback } from "react";
import { getHistoriesByPetId } from "../../api/historyService";
export const usePetHistories = (id, trigger, initialPage = 1, initialLimit = 10) => {
    const [histories, setHistories] = useState({
        data: [],
        pagination: { page: initialPage, limit: initialLimit, totalPages: 1, total: 0 },
        sort: null,
        search: null,
    });
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    const fetchData = useCallback(
        async (page = initialPage, limit = initialLimit, append = false, search = searchTerm) => {
            setLoading(true);
            try {
                const response = await getHistoriesByPetId(id, page, limit);
                setHistories(prev => {
                if (append) {
                    return {
                    ...response,
                    data: [...(prev.data || []), ...response.data],
                    };
                }
                // 🔑 Reset pagination when not appending (fresh search or initial load)
                return {
                    ...response,
                    pagination: { ...response.pagination, page }, 
                };
                });
                return response;
            } catch (err) {
                console.error("Failed to fetch inventory items:", err);
            } finally {
                setLoading(false);
            }
        },
        [initialPage, initialLimit, searchTerm]
    );

    useEffect(() => {
        fetchData(initialPage, initialLimit, false, searchTerm);
    }, [trigger, fetchData, initialPage, initialLimit, searchTerm]);

    const loadMore = async () => {
        const nextPage = histories.pagination.page + 1;
        if (nextPage <= histories.pagination.totalPages) {
        await fetchData(nextPage, histories.pagination.limit, true, searchTerm);
        }
    };

    // 🔎 Called by SearchBox
    const searchFunction = async (page, keywords) => {
        setSearchTerm(keywords);
        // Reset results and pagination when searching
        await fetchData(page, histories.pagination.limit, false, keywords);
    };

    const resetParent = async () => {
        setSearchTerm("");
        await fetchData(initialPage, initialLimit, false, "");
    };

    return { histories, loading, loadMore, searchFunction, resetParent };
};